module.exports = __webpack_public_path__ + "img/threeSteps.5b350e3e.png";